module.exports = __webpack_public_path__ + "static/media/team-introduction-8.e08d669b.jpg";